__webpack_require__.p = "/themes/custom/novasol_theme/assets/";